import React from "react";
import { Box, IconButton, Typography } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import MuiStylesIndicationsPage from "~/components/indicationsPage/MuiStylesIndicationsPage";
import TitleContainer from "~/components/common/titleContainer/TitleContainer";
import Footer from "~/components/common/footerContainer/FooterContainer";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { useTranslation } from "react-i18next";

const HowIndicationsWork = (props) => {
	const classes = MuiStylesIndicationsPage();
	const { t } = useTranslation();
	const footer = () => {
		return <Footer section="indicacoes" />;
	};

	const handleBackClick = () => {
		props.history.push("/indicacoes");
	};
	return (
		<>
			<TitleContainer loading={false} headerStyle={{ boxShadow: "0", padding: "0" }} footer={footer()}>
				<IconButton onClick={handleBackClick} style={{ marginTop: "0rem", padding: "0", color: "#000" }}>
					<ArrowBackIosIcon />
				</IconButton>
				<Typography variant="h5" className={classes.sectionTitle} style={{ marginTop: "1.5rem", fontSize: "1.3rem" }}>
					{t('How referrals work')}
				</Typography>

				<Box marginBottom="1rem">
					<div className={classes.numberCircle}>1</div>
					<Typography className={classes.sectionTitle}>{t('Refer your friends')}</Typography>
					<Typography className={classes.sectionContent}>
						{t('You share your link with other professionals so they can download the app')}
					</Typography>
					<Typography className={classes.tips}>{t('TIPS:')}</Typography>
					<Typography className={classes.tips}>{t('- Send encouraging messages;')}</Typography>
					<Typography className={classes.tips}>{t('- Post frequently on your stories;')}</Typography>
					<Typography className={classes.tips}>{t('- Keep the link pinned in your Instagram bio;')}</Typography>
					<Typography className={classes.tips}>{t('- Create posts talking about Refer and Earn')}</Typography>
				</Box>

				<Box marginBottom="1rem">
					<div className={classes.numberCircle}>2</div>
					<Typography className={classes.sectionTitle}>{t('Earn money')}</Typography>
					<Typography className={classes.sectionContent}>
						{t('For each new subscription from your referral you earn a bonus')}
					</Typography>
				</Box>

				<Box marginBottom="1rem">
					<div className={classes.numberCircle}>3</div>
					<Typography className={classes.sectionTitle}>{t('Follow')}</Typography>
					<Typography className={classes.sectionContent}>
						{t('Track your earnings and keep encouraging your friends!')}
					</Typography>
				</Box>
			</TitleContainer>
		</>
	);
};

export default withRouter(HowIndicationsWork);
